import { useEffect } from 'react'

import { AddToBagContainer } from '../../components/pages/products/ProductPage/contexts/AddToBagContainer'

const NEXT_PUBLIC_SHOPIFY_SHOP_NAME = process.env.NEXT_PUBLIC_SHOPIFY_SHOP_NAME
const NEXT_PUBLIC_SHOPIFY_SHOP_DOMAIN = process.env.NEXT_PUBLIC_SHOPIFY_SHOP_DOMAIN
const shopifyShopUrl = `${NEXT_PUBLIC_SHOPIFY_SHOP_NAME ?? 'wearfigs-staging'}.${
  NEXT_PUBLIC_SHOPIFY_SHOP_DOMAIN ?? 'myshopify.com'
}`

type LineItemProps = { gift: { _gift_id: string; name: string; email: string; message: string } }

type UseRiseAiScriptProps = {
  giftCardShopifyId: string | undefined
}

export const useRiseAiScript = ({ giftCardShopifyId }: UseRiseAiScriptProps) => {
  const { addToBag } = AddToBagContainer.useContainer()

  useEffect(() => {
    // See: https://help.rise.ai/en/articles/4858938-using-rise-with-a-headless-store
    globalThis.Rise = giftCardShopifyId
      ? {
          full_product: { available: true },
          is_floating_cart_theme: true,
          is_product_page: true,
          product: { id: parseInt(giftCardShopifyId) },
          using_add_to_cart_flow: true,
          onGiftAdded: (lineItemProps: LineItemProps) => addToBag(lineItemProps.gift),
        }
      : undefined

    return () => {
      globalThis.Rise = undefined
    }
  }, [addToBag, giftCardShopifyId])

  useEffect(() => {
    if (globalThis.document && giftCardShopifyId) {
      const targetScriptElement = globalThis.document.getElementById('@figs:rise')
      const addToCartButton = globalThis.document.querySelector('.Rise-add-to-cart-button')
      const addToCartButtonInitializedAttr = addToCartButton?.getAttribute('data-initialized')
      if (targetScriptElement && addToCartButtonInitializedAttr) {
        return
      }

      new Promise((resolve, reject) => {
        const script = globalThis.document.createElement('script')
        script.id = '@figs:rise'
        script.onload = resolve
        script.onerror = reject
        script.async = true
        script.src = `https://str.rise-ai.com/?shop=${shopifyShopUrl}`
        const targetElement = globalThis.document.getElementById('@figs:rise')
        if (targetElement && targetElement.outerHTML) {
          targetElement.outerHTML = ''
        }
        globalThis.document.body.appendChild(script)
        addToCartButton?.setAttribute('data-initialized', 'true')
      })
    }
  }, [giftCardShopifyId])
}
